export const getLanguage = () => {
  const languageCode = localStorage.getItem('i18nextLng');

  return {
    languageCode,
    isFrench: languageCode === 'fr',
  };
};

export const getTranslatedItem = (data) => {
  const { languageCode } = getLanguage();
  return data?.find((item) => item.languageCode === languageCode);
};

/**
 * Narrows an i18next language (which may carry a region, e.g. `fr-FR`) to the
 * bare code the API expects, falling back to the default when none is set.
 *
 * The list of accepted codes is deliberately not duplicated here: the API owns
 * it through the `LanguageCode` enum and falls back to its own default for any
 * code it does not recognise.
 */
export const resolveLanguageCode = (language?: string): string =>
  language?.split('-')?.[0]?.toLowerCase() || 'fr';
